import React, { createContext, useEffect, useState, useCallback, useContext } from 'react';
import { TtsSellerSafe } from '../clientContracts/tiktokShop/entities';
import { GetClientTtsSellersSafeDCO } from '../clientContracts/tiktokShop/tiktokShopDCOs';
import UserContext from './userContext';
import requestHandler from '../utils/requestHandler';

interface TtsSellerContextType {
    sellers: TtsSellerSafe[];
    setSellers: React.Dispatch<React.SetStateAction<TtsSellerSafe[]>>;
    loading: boolean;
    setLoading: React.Dispatch<React.SetStateAction<boolean>>;
    refetch: () => Promise<void>; // Adding refetch function to allow manual refresh
}

export const TtsSellerContext = createContext<TtsSellerContextType>({
    sellers: [],
    setSellers: () => {
        /* noop */
    },
    loading: true,
    setLoading: () => {
        /* noop */
    },
    refetch: async () => {
        /* noop */
    },
});

interface TtsSellerProviderProps {
    children: React.ReactNode;
}

export const TtsSellerProvider: React.FC<TtsSellerProviderProps> = ({ children }) => {
    const [sellers, setSellers] = useState<TtsSellerSafe[]>([]);
    const [loading, setLoading] = useState(false);
    const user = useContext(UserContext);

    const fetchTtsSellers = useCallback(async () => {
        if (user?.activeClient?.id) {
            setLoading(true);
            const results = await requestHandler<GetClientTtsSellersSafeDCO>(
                'GET',
                '/api/tiktok-shop/sellers',
            );
            if (results.success) {
                const { payload } = results;
                setSellers(payload.sellers);
            }
            setLoading(false);
        }
    }, [user?.activeClient?.id]);

    useEffect(() => {
        fetchTtsSellers();
    }, [fetchTtsSellers]);

    return (
        <TtsSellerContext.Provider
            value={{
                sellers,
                setSellers,
                loading,
                setLoading,
                refetch: fetchTtsSellers,
            }}
        >
            {children}
        </TtsSellerContext.Provider>
    );
};
